/**
 * WorldEnvironment property formatter - formats WorldEnvironment properties for display
 */
export function formatWorldEnvironmentProperties(properties) {
    const sections = [];
    // Environment section
    const environmentItems = [
        { label: 'Environment', value: properties.environment || '(none)' },
    ];
    if (properties.camera_attributes) {
        environmentItems.push({ label: 'Camera Attributes', value: properties.camera_attributes });
    }
    sections.push({
        title: 'Environment',
        items: environmentItems,
    });
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map